import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Bell, CheckCheck } from "lucide-react";

export function NotificationBell() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const load = useCallback(() => {
    api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
  }, []);
  const openNotif = async (n) => {
    if (!n.is_read) { await api.post(`/notifications/${n.id}/read`); load(); }
    if (n.link) nav(n.link);
  };
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [load]);

  const unread = items.filter((i) => !i.is_read).length;
  const markAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="relative" data-testid="notifications-bell">
          <Bell className="h-5 w-5" />
          {unread > 0 && (
            <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-bold text-primary-foreground" data-testid="notif-count">
              {unread}
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 p-0">
        <div className="flex items-center justify-between border-b border-border p-3">
          <p className="text-sm font-semibold">Notifications</p>
          {unread > 0 && (
            <button onClick={markAll} className="flex items-center gap-1 text-xs text-primary" data-testid="mark-all-read">
              <CheckCheck className="h-3 w-3" />Mark all read
            </button>
          )}
        </div>
        <div className="max-h-96 overflow-y-auto">
          {items.length === 0 && <p className="p-4 text-center text-sm text-muted-foreground">No notifications.</p>}
          {items.map((n) => (
            <button key={n.id} onClick={() => openNotif(n)} className={`block w-full border-b border-border p-3 text-left text-sm hover:bg-accent ${n.is_read ? "opacity-60" : "bg-primary/5"}`} data-testid={`notif-${n.id}`}>
              <p>{n.message}</p>
              <p className="mt-1 text-xs text-muted-foreground">{new Date(n.created_at).toLocaleString()}</p>
            </button>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
